import Super from 'client-portal/routes/-request/cancelled';
import classic from 'ember-classic-decorator';

@classic
export default class WidgetCancelled extends Super {}
